import zodToJsonSchema from "zod-to-json-schema";
import { DataConfigSchema } from "./dataConfigSchema";
import { UIConfigSchema } from "./uiConfigSchema";

export * from "./dataConfigSchema";
export * from "./uiConfigSchema";

export const UIConfigJsonSchema = zodToJsonSchema(UIConfigSchema);
export const DataConfigJsonSchema = zodToJsonSchema(DataConfigSchema);
